module.exports = __webpack_public_path__ + "static/media/searcy.00f4b30b.jpg";